export default __webpack_public_path__ + "static/loader-65c36a92f006e8f0ce667befad6c3dfb.gif";